// src/config/evidenciaRules.js
//
// Reglas de evidencia por módulo para validar el cierre de informe.
// Incremento VC: SOLO se enforcea el mínimo de fotos al cierre.
// No hay tope máximo enforceado (ni captura ni cierre) por ahora.
//
// Campos:
//   minFotos      -> mínimo de fotos activas (baja IS NULL) para poder cerrar.
//   maxFotos      -> null = sin tope enforceado. Nominal PO (diferido):
//                    trianual/toolbox 4, amarre 3. Enforzarlo requerirá el
//                    DELETE de backend en handleQuitarEvidencia.
//   minVideos     -> 0 (video no implementado).
//   maxVideos     -> 0 (video no implementado).
//   combinaciones -> reglas disyuntivas para el futuro con video. null hoy.

export const EVIDENCIA_RULES = {
  trianual: { minFotos: 2, maxFotos: null, minVideos: 0, maxVideos: 0, combinaciones: null },
  amarre:   { minFotos: 2, maxFotos: null, minVideos: 0, maxVideos: 0, combinaciones: null },
  toolbox:  { minFotos: 1, maxFotos: null, minVideos: 0, maxVideos: 0, combinaciones: null },
};

// Futuro (cuando entre video):
//   amarre.combinaciones = [{ fotos: 2, videos: 1 }, { fotos: 3, videos: 0 }]
//   toolbox.maxFotos = 4  // requiere multi-foto en backend
//   trianual.maxFotos = 4 // requiere DELETE backend para poder bajar el conteo
